const bank = process.env.BANK

const componentConfig = {
  homepageTutorial: {
    // Map bank -> tutorial variant key
    variant: () => ({
      NEXIBUSINESS: 'NEXIBUSINESS',
      UCI: 'UCI'
    })[bank]
  }
}

export default componentConfig
